import React, { Component } from "react";
// import { getDistance } from 'geolib';
// import { FaPlane } from "react-icons/fa";
import {
  Card,
  CardBody
} from "shards-react";


export default class FlightInfo extends Component {
  render() {
    const {
      callsign,
      aircraft,
    } = this.props.data;

    const { theme } = this.props

    return (
      <Card className={"sidebar-flightinfo"} style={{backgroundColor: theme.primary, color: theme.textPrimary}}>
        <CardBody>
    
          <div className={"subdetailsFlex"}>
            <div className="logoAndCallsignWrapper">
                <img
                  style={{ width: "auto", maxHeight: "10em" , maxWidth: "20em" }}
                  src={
                    //`http://5.199.141.195/airlines/get_image.php?airlineCode=${callsign.substr(0, 3)}`
                    //`http://127.0.0.1/airlines/get_fltinfo.php?aircraft=${aircraft}&callsign=${callsign}`
                    `https://www.x-flightserver.org/airlines/get_fltinfo.php?aircraft=${aircraft}&callsign=${callsign}`
                  }
                  alt={""}
                />
              </div>
          </div>
        </CardBody>
      </Card>
    );
  }
}

